import React, { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { secs } from "../../hooks/useVideoStudio";

export const EditorHeader = ({ video, onRename, onDelete }) => {
  const [name, setName] = useState(video.name);
  const [confirm, setConfirm] = useState(false);
  useEffect(() => { setName(video.name); }, [video.name]);
  useEffect(() => { if (!confirm) return undefined; const t = setTimeout(() => setConfirm(false), 4000); return () => clearTimeout(t); }, [confirm]);

  const commit = () => {
    const n = name.trim();
    if (n && n !== video.name) onRename(n);
    else setName(video.name);
  };

  return (
    <div className="flex items-start gap-3">
      <div className="min-w-0 flex-1">
        <input value={name} onChange={(e) => setName(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
          maxLength={80} data-testid="video-name-input" aria-label="Video name"
          className="w-full bg-transparent text-lg font-semibold tracking-tight text-slate-900 rounded-md px-1 -mx-1 hover:bg-slate-100 focus:bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500/30" />
        <p className="text-xs text-slate-500 mt-0.5" data-testid="video-meta">{video.clips.length} clip{video.clips.length === 1 ? "" : "s"} · {secs(video.length)} · {video.aspect}</p>
      </div>
      <button onClick={() => (confirm ? onDelete() : setConfirm(true))} data-testid="video-delete-btn"
        className={`h-8 px-3 rounded-lg text-xs flex items-center gap-1.5 transition-colors shrink-0 ${confirm ? "bg-rose-600 text-white" : "text-slate-500 hover:text-rose-600 hover:bg-rose-50"}`}>
        <Trash2 size={13} /> {confirm ? "Tap again to delete" : "Delete"}
      </button>
    </div>
  );
};

export default EditorHeader;
